var render = function render(_c,_vm){return _c('div',{staticClass:"array-field__boolean"},[_c('div',{staticClass:"array-field__checkbox"},[(_vm.props.value)?_c('i',{staticClass:"iconoir-check"}):_c('i',{staticClass:"iconoir-cancel array-field__checkbox--false"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }